import { render } from "./FormField.vue?vue&type=template&id=0a2d67ec&scoped=true"
import script from "./FormField.vue?vue&type=script&lang=js"
export * from "./FormField.vue?vue&type=script&lang=js"

import "./FormField.vue?vue&type=style&index=0&id=0a2d67ec&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2d67ec"]])

export default __exports__